import Smart from 'hocs/smart';
import View from './distance-view';

export default Smart(
  View,
  state => ({
    units: state.settings.units.distance
  }),
  () => ({
  })
);
